import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/HealthCareInsights/index.tsx");
